import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import routeModules from './modules/index'

import { HOME_PATH } from './constants'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: HOME_PATH,
  },
  ...routeModules,
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  // 切换路由时回到顶部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

export default router
export { router }
